import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import { useField } from 'formik'
import { z } from 'zod'
import { makeZodI18nMap } from 'zod-i18n-map'

import { getZodMessage } from 'utils/validation.util'

import { InputStyle } from './Input'

const FieldCheckbox = ({
  className,
  children,
  showError,
  ...props
}: {
  name: string
  children: string | JSX.Element
  className?: string
  showError?: boolean
}) => {
  const { t } = useTranslation(['zod'])
  z.setErrorMap(makeZodI18nMap(t))

  const [field, meta] = useField(props)
  return (
    <div className="relative">
      <label className={clsx('my-5 block w-full cursor-pointer', className)}>
        <input {...field} {...props} className="text-black" type="checkbox" />
        <span className="ml-2">{children}</span>
      </label>
      {(meta.touched || showError) && meta.error ? (
        <div
          className={clsx(
            InputStyle.error,
            'absolute left-0 bottom-[-1rem] z-0 w-full text-left'
          )}
        >
          {getZodMessage(meta.error, t('zod:' + meta.error))}
        </div>
      ) : null}
    </div>
  )
}

export default FieldCheckbox
